__turbopack_context__.v({
  "intro": "jobIntroduction-module-scss-module__Glgmxa__intro",
});
